import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import { buildFilterParams } from '@/pages/DataReporting/utils';
import {
  IReportConfig,
  IReportDataServer,
  IReportFilterParams,
} from '@/types/reports';

class ReportsApi extends AbortControllerManager {
  private readonly BASE_REPORTS_URL = '/v2/reports';

  constructor() {
    super();
  }

  async getReportConfig(): Promise<IReportConfig[]> {
    const signal = this.createAbortController('getReportConfig');
    const { data } = await authClient.get<{ data: IReportConfig[] }>(
      this.BASE_REPORTS_URL,
      { signal },
    );
    return data.data;
  }

  private filterAllParams(params: URLSearchParams): URLSearchParams {
    const filtered = new URLSearchParams();

    for (const [key, value] of params.entries()) {
      if (value !== '_all') {
        filtered.append(key, value);
      }
    }

    return filtered;
  }

  async getReportDataById(
    reportId: string,
    filters: IReportFilterParams = {},
  ): Promise<IReportDataServer[]> {
    const signal = this.createAbortController(`getReportDataById_${reportId}`);
    const params = buildFilterParams(filters);
    const filteredParams = this.filterAllParams(params);

    const { data } = await authClient.get<{ data: IReportDataServer[] }>(
      `${this.BASE_REPORTS_URL}/${reportId}`,
      { signal, params: filteredParams },
    );
    return data.data;
  }
}

export const reportsApi = new ReportsApi();
